import React, { useState, useEffect } from 'react';
import axios from 'axios';
import authMenuCss from './AuthMenu.module.css'
import adminSideMenuCss from '../AdminSideMenu/AdminSideMenu.module.css'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LockResetIcon from '@mui/icons-material/LockReset';
import HelpIcon from '@mui/icons-material/Help';
import PolicyIcon from '@mui/icons-material/Policy';
import LogoutIcon from '@mui/icons-material/Logout';
import { GrNotes } from "react-icons/gr";
import { FaPlay } from "react-icons/fa";
import { PiExamFill } from "react-icons/pi";
import { MdOutlineInsights  } from "react-icons/md";
import { FaMapMarkedAlt } from 'react-icons/fa';

import { 
    Work, 
    PictureAsPdf, 
    EditNote,
    ConnectWithoutContact
} from '@mui/icons-material';
import avatarImg from "../../../images/avatar.png";
import { setFetching, setAllMessagesArray, setMessages, setProfileImg } from '../../../redux/states';
import { useDispatch, useSelector } from "react-redux";
import { useConfirm } from "material-ui-confirm";
import {useNavigate, Link, useLocation} from "react-router-dom";
import { checkAuthenticatedUser } from '../../../utils/client-functions';
import { useErrorSetter, useSuccessSetter } from '../../../hooks/useUiMessages';
import {useTheme} from "../Theme/ThemeContext";
import {AuthBoxStyled} from "../../../styled/Header";
import {
    HelperButtonsStyled,
    LinksButtonsStyled,
    SideBarItemsStyled,
    SideBarWrapperStyled
} from "../../../styled/SideBar";
import featureTutorial from "../../UI/Learn/data";


const AuthSideMenu = ({ opened, arrayDetails = [], onSwitch }) => {
    const { userFirstName, profileImg } = useSelector((state) => state.stateData);
    const dispatch = useDispatch();
    const confirm = useConfirm();
    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const featureParam = segments[segments.length - 1];
    const featureData = featureTutorial.filter((item) => item.hub === featureParam);
    const navigate = useNavigate();
    const isAuth = localStorage?.getItem("token")
    const [activeIndex, setActiveIndex] = useState(null);
    const {themeName} = useTheme();


    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();

    // Set the active index to the latest session (original last element)
    useEffect(() => {
        const len = Array.isArray(arrayDetails) ? arrayDetails.length : 0;
        setActiveIndex(len > 0 ? len - 1 : null);
    }, [arrayDetails])

    // Ensure profile image is available: if missing in Redux, fetch it silently and cache
    useEffect(() => {
        if (profileImg) return; // already present
        const token = localStorage?.getItem('token');
        if (!token) return;
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get('/dashboard/get-profile', {
                    headers: { 'x-access-token': token }
                });
                const fetched = resp?.data?.profile?.profileImg;
                if (!cancelled && fetched) {
                    dispatch(setProfileImg(fetched));
                }
            } catch (_) {
                // silent fail
            }
        })();
        return () => { cancelled = true; };
    }, [dispatch, profileImg]);

    const handleLogOut = () => {
        localStorage?.removeItem("token");
        window.location.reload()
    }    

    const handleLogIn = () => {
        navigate("/popin")
    }

    const handleNavigateProfile = () => {
        const prevPath = location.pathname
        sessionStorage.setItem("prevPath", prevPath)
        navigate("/user/dashboard/profile")
    }

    const handleChangePass = () => {
        const prevPath = location.pathname
        sessionStorage.setItem("prevPath", prevPath)
        navigate("/user/dashboard/reset-pass")
    }
    const handleDashSupport = () => {
        const prevPath = location.pathname
        sessionStorage.setItem("prevPath", prevPath)
        navigate("/user/dashboard/dash-support")
    }

    
    // Format a readable date/time
    const formatDateTime = (dt) => {
        try {
            const d = new Date(dt);
            if (isNaN(d.getTime())) return '';
            return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        } catch(_) { return ''; }
    };

    // Switch session using ORIGINAL index mapping
    const continueDiffChat = (originalIndex) => {
        confirm({
            title: `Switch Session?`,
            description: `Click OK to switch to selected`,
        })
        .then(() => {
            dispatch(setMessages(arrayDetails[originalIndex]));
            setActiveIndex(originalIndex)
            successSetter("Session Switched")
            try { if (typeof onSwitch === 'function') onSwitch(originalIndex); } catch(_) {}
        })
        .catch(() => {
            return    
        });
    }

    // Delete a session by its ORIGINAL index (before reversal)
    const handleDeleteMsgSession = async (originalIndex, sessionMessages) => {
        try {
            //must await
            await checkAuthenticatedUser()
        } catch (error) {
            dispatch(setFetching(false));
            return navigate("/popin?chat");      
        }
        confirm({
            title: `Delete "${sessionMessages[0]?.content?.slice(0, 30) || 'Session'}"?`,
            description: `Click OK to delete the selected session forever`,
        })
        .then(async () => {
            dispatch(setFetching(true))

            const body = { indexOfChat: originalIndex }

            try {
                const response = await axios.post("/delete-askme-session", body, {
                    headers: {
                        "x-access-token": isAuth,
                    },
                });
                // Update sessions using server echo; then refetch /user/messages to include meta (createdAt)
                let sessions = response?.data || [];
                try {
                    const m = await axios.get('/user/messages', { headers: { 'x-access-token': isAuth } });
                    const arrRaw = Array.isArray(m?.data?.messages) ? m.data.messages : sessions;
                    const meta = m?.data?.threadsMeta || [];
                    sessions = arrRaw.map((a,i) => { try { Object.defineProperty(a,'__meta',{ value: meta[i]||{}, enumerable:false}); } catch(_){} return a; });
                } catch(_) {}
                dispatch(setAllMessagesArray(sessions))
                if (sessions.length > 0) dispatch(setMessages(sessions[sessions.length - 1]))
                dispatch(setFetching(false))
                successSetter("Session Deleted")
            } catch (error) {
                dispatch(setFetching(false))
                errorSetter(error?.response?.data?.message || 'Failed to delete session')
            }
        })
        .catch(() => {
            return    
        });
    }

    const MenuDisplay = () => {
        return (                    
            <ul className={adminSideMenuCss.SideMenuItems}>
                 <li>
                    <Link to="/user/dashboard/resume">
                        <EditNote />
                        <span>Create Resume</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/resume-hub">
                        <PictureAsPdf />
                        <span>Resumes & Cover Ltrs</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/job-hub">
                        <Work />
                        <span>Job Connection/Applications</span> 
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/career-roadmap">
                        <FaMapMarkedAlt fontSize={"1.3rem"} />
                        <span>Career Roadmap</span> <span className={adminSideMenuCss.newFeat}>NEW</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/mock" >
                        <PiExamFill fontSize="1.3rem" />
                        <span>Simulate any Exam</span> <span className={adminSideMenuCss.newFeat}>NEW</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/mock/written" >
                        <MdOutlineInsights fontSize="1.3rem" />
                        <span>View Simulated Exams</span> <span className={adminSideMenuCss.newFeat}>NEW</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/courses">
                        <FaPlay fontSize={"1.3rem"} />
                        <span>Ai Curated Courses</span>
                    </Link>
                </li>
                <li>
                    <Link to="/user/dashboard/referral-hub" >
                        <ConnectWithoutContact />
                        <span>Earn for Life</span> <span className={adminSideMenuCss.newFeat}>NEW</span>
                    </Link>
                </li>
            </ul>
        )
    }

    const ItemsNamesArray = () => { 
        const isChatPath = location.pathname.startsWith("/chat");
        
        return ( 
           <div className={authMenuCss.Items}>
                {!isChatPath ? (
                    <MenuDisplay />
                ) : !isAuth ? (
                    <div className={authMenuCss.NonMonthlySubDisplay}>
                         <p>Login below to display chat history here.</p>
                    </div>
                ) : (arrayDetails?.length < 1 || (arrayDetails.length === 1 && arrayDetails[0]?.length < 1)) ? (
                    <div className={authMenuCss.NonMonthlySubDisplay}>
                        <p>Start a chat to view chat history here.</p>
                    </div>
                ) : (
                    // Latest-first ordering: reverse the array for display
                    [...arrayDetails].reverse().map((sessionMessages, revIndex) => {
                        const originalIndex = arrayDetails.length - 1 - revIndex;
                        const isActive = activeIndex === originalIndex;
                        
                        // Ignore empty sessions in the list unless it's the active one
                        if (sessionMessages.length < 1 && !isActive) return null;

                        const createdAt = sessionMessages && sessionMessages.__meta ? sessionMessages.__meta.createdAt : undefined;
                        const createdAtStr = formatDateTime(createdAt);

                        const isDark = themeName === 'dark';

                        // Futuristic Glassmorphic Styles for Chat Items
                        const chatItemBaseStyle = {
                            display: 'flex', 
                            justifyContent: "space-between", 
                            alignItems: "center", 
                            height: "65px",
                            marginBottom: '12px',
                            padding: '10px 15px',
                            borderRadius: '14px',
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            position: 'relative',
                            overflow: 'hidden',
                            border: isActive ? '1px solid rgba(62, 143, 147, 0.4)' : (isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.08)'),
                            background: isActive 
                                ? 'linear-gradient(135deg, rgba(62, 143, 147, 0.15) 0%, rgba(62, 143, 147, 0.05) 100%)' 
                                : (isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)'),
                            backdropFilter: 'blur(10px)',
                            boxShadow: isActive 
                                ? '0 4px 15px rgba(62, 143, 147, 0.2), inset 0 0 10px rgba(62, 143, 147, 0.05)' 
                                : (isDark ? '0 4px 12px rgba(0, 0, 0, 0.1)' : '0 2px 8px rgba(0, 0, 0, 0.05)'),
                        };

                        return (
                            <div
                                style={chatItemBaseStyle}
                                key={originalIndex}
                                className={isActive ? authMenuCss.ItemActiveChat : authMenuCss.ItemChat}
                                onMouseEnter={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = isDark ? 'rgba(62, 143, 147, 0.12)' : 'rgba(62, 143, 147, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(62, 143, 147, 0.3)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = isDark ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)';
                                        e.currentTarget.style.borderColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }
                                }}
                            >
                                <div onClick={() => continueDiffChat(originalIndex)} style={{ width: "85%", display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <div style={{ display:'flex', alignItems:'center', gap: '8px' }}>
                                        <span style={{ 
                                            fontSize: '0.85rem',
                                            fontWeight: isActive ? "700" : "500", 
                                            color: isActive ? "#3E8F93" : (isDark ? "rgba(255, 255, 255, 0.85)" : "#0C1E28"),
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {(sessionMessages[0]?.content || 'New Session').slice(0, 24) + (sessionMessages[0]?.content?.length > 24 ? '...' : '')}
                                        </span>
                                        {isActive && <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#3E8F93', boxShadow: '0 0 8px #3E8F93' }} />}
                                    </div>
                                    {createdAtStr && (
                                        <span style={{ 
                                            fontSize: '0.65rem', 
                                            color: isActive ? "rgba(62, 143, 147, 0.7)" : (isDark ? "rgba(255, 255, 255, 0.45)" : "rgba(12, 30, 40, 0.6)"),
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}>
                                            {createdAtStr}
                                        </span>
                                    )}
                                </div>
                                <div 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteMsgSession(originalIndex, sessionMessages);
                                    }} 
                                    style={{ 
                                        color: 'rgba(239, 83, 80, 0.6)', 
                                        padding: '8px',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(239, 83, 80, 0.1)';
                                        e.currentTarget.style.color = 'rgba(239, 83, 80, 1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'transparent';
                                        e.currentTarget.style.color = 'rgba(239, 83, 80, 0.6)';
                                    }}
                                >
                                    <DeleteForeverIcon fontSize='small' />
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        ); 
    };

    return (
        <AuthBoxStyled theme={themeName} className={opened ? authMenuCss.ContainerOpen : authMenuCss.ContainerClose}>

            <SideBarWrapperStyled theme={themeName}>
                <span className="imgBox">
                    <img 
                        src={profileImg || avatarImg}  
                        alt="Your Avatar"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                            background: "#f5f5f5"
                        }}
                    />
                </span>

                <div className="welcome">
                    <h4>Welcome Back</h4>
                    <p>{userFirstName}</p>
                </div>
            </SideBarWrapperStyled>
            
            <SideBarItemsStyled theme={themeName}>
                <ItemsNamesArray />
            </SideBarItemsStyled>

            <HelperButtonsStyled >
                {featureData.map((feature, index) => (
                    <LinksButtonsStyled
                        theme={themeName}
                        color={themeName === 'dark' ? '#fff' : '#5fbec5'}
                        $border={themeName === 'dark' ? '1px solid #fff': '1px solid #5fbec5'}
                        width="95%"
                        $pad="1rem"
                        key={index}
                        onClick={() => window.open(`/how-i-work/${feature.slug}`, '_blank')}

                    >
                        <GrNotes
                            fontSize='small'
                        />
                        HOW I WORK

                    </LinksButtonsStyled>
                ))}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', width: '100%', justifyContent: 'space-between', padding: '0.6rem', boxSizing: 'border-box' }}>
                    <LinksButtonsStyled
                        theme={themeName}
                        color={themeName === 'dark' ? '#fff' : '#5fbec5'}
                        $border={themeName === 'dark' ? '1px solid #fff': '1px solid #5fbec5'}
                        onClick={handleNavigateProfile}
                        style={{ width: '48%', padding: '0.45rem 0.35rem', fontSize: '.75rem' }}
                    >
                        <ManageAccountsIcon fontSize='small' style={{ fontSize: '0.9rem' }} />
                        <span style={{ fontSize: '.85rem' }}>PROFILE</span>
                    </LinksButtonsStyled>

                    <LinksButtonsStyled
                        theme={themeName}
                        color={themeName === 'dark' ? '#fff' : '#5fbec5'}
                        $border={themeName === 'dark' ? '1px solid #fff': '1px solid #5fbec5'}
                        onClick={handleChangePass}
                        style={{ width: '48%', padding: '0.45rem 0.35rem', fontSize: '.75rem' }}
                    >
                        <LockResetIcon fontSize='small' style={{ fontSize: '0.9rem' }} />
                        <span style={{ fontSize: '.85rem' }}>CHANGE</span>
                    </LinksButtonsStyled>

                    <LinksButtonsStyled
                        theme={themeName}
                        color={themeName === 'dark' ? '#fff' : '#5fbec5'}
                        $border={themeName === 'dark' ? '1px solid #fff': '1px solid #5fbec5'}
                        onClick={handleDashSupport}
                        style={{ width: '48%', padding: '0.45rem 0.35rem', fontSize: '.75rem' }}
                    >
                        <HelpIcon fontSize='small' style={{ fontSize: '0.9rem' }} />
                        <span style={{ fontSize: '.85rem' }}>SUPPORT</span>
                    </LinksButtonsStyled>

                    <LinksButtonsStyled
                        theme={themeName}
                        color={themeName === 'dark' ? '#fff' : '#5fbec5'}
                        $border={themeName === 'dark' ? '1px solid #fff': '1px solid #5fbec5'}
                        onClick={() => navigate('/privacy')}
                        style={{ width: '48%', padding: '0.45rem 0.35rem', fontSize: '.75rem' }}
                    >
                        <PolicyIcon fontSize='small' style={{ fontSize: '0.9rem' }} />
                        <span style={{ fontSize: '.85rem' }}>TERMS</span>
                    </LinksButtonsStyled>

                    <LinksButtonsStyled
                        theme={themeName}
                        $logout={isAuth ? true : false}
                        color={isAuth ? "crimson" : themeName === 'dark' ? '#0C1E28' : '#5fbec5'}
                        $border={isAuth ? "2px solid crimson" : themeName === 'dark' ? '#0C1E28' : '#5fbec5'}
                        onClick={isAuth ? handleLogOut : handleLogIn}
                        style={{ width: '100%', padding: '0.45rem 0.35rem', fontSize: '.75rem' }}
                    >
                        <LogoutIcon fontSize='small' style={{ fontSize: '0.9rem' }} />
                        <span style={{ fontSize: '.85rem' }}>{isAuth ? "LOGOUT" : "LOGIN"}</span>
                    </LinksButtonsStyled>
                </div>

            </HelperButtonsStyled>
        </AuthBoxStyled>
    )
}

export default AuthSideMenu;